/**
 * Extracts information about a file path from a given string.
 *
 * @param {string} filePath - The input string containing a file path.
 * @returns {{
 *   path: string | undefined,  // The directory path, if present.
 *   file: string | undefined,  // The file name with extension, if present.
 *   name: string | undefined,  // The file name without extension, if present.
 *   ext: string | undefined   // The file extension, if present.
 * }}
 * @example
 * pathInfo(/path/to/file.txt);       	// { path: "/path/to/", file: "file.txt", name: "file", ext: ".txt" }
 * pathInfo(/path/to/file);       		// { path: "/path/to/", file: "file.txt", name: "file", ext: undefined }
 * pathInfo(file.txt);    				// { path: undefined, file: "file.txt", name: "file", ext: ".txt" }
 */
export function pathInfo(filePath: string): {
	path: string | undefined;
	file: string | undefined;
	name: string | undefined;
	ext: string | undefined;
} {
	const match = filePath.match(/(.*?\/)?(([^/]*?)(\.[^/.]+?)?)(?:[?#].*)?$/);

	return {
		path: match[1],
		file: match[2],
		name: match[3],
		ext: match[4],
	};
}
